import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { RastreadorModeloService } from 'app/services/rastreador-modelo.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rastreador-modelo-list',
  templateUrl: './rastreador-modelo-list.component.html',
  styleUrls: ['./rastreador-modelo-list.component.scss']
})
export class RastreadorModeloListComponent implements OnInit {
  
  // Private variables
  private _unsubscribeAll: Subject<any> = new Subject();
  
  // Public variables
  public loading: boolean = false;
  public ColumnMode = ColumnMode;
  public rows: any[] = [];
  public basicSelectedOption: number = 10;
  public contentHeader: any;
  private tempData = [];
  public temp = [];
  public selectedStatus: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(
    private rastreadorModeloService: RastreadorModeloService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.loading = true;
    
    try {
      const result = await this.rastreadorModeloService.findAll();
      this.rows = Array.isArray(result) ? result : [];
      this.temp = Array.isArray(result) ? [...result] : [];
    } catch (error) {
      console.error('Erro ao carregar modelos de rastreador:', error);
      this.rows = [];
      this.temp = [];
    } finally {
      this.loading = false;
    }

    // Configuração do cabeçalho
    this.contentHeader = {
      headerTitle: "Modelos de Rastreador",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          { name: "Início", isLink: false },
          { name: "Modelos de Rastreador", isLink: false }
        ]
      }
    };
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // Add filter methods
  nomeFilter(event) {
    const val = event.target.value.toLowerCase();

    const temp = this.temp.filter(function (d) {
      if (d.nome != null) {
        return d.nome.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });

    this.rows = temp;
    this.table.offset = 0;
  }

  statusFilter() {
    if (this.selectedStatus == 0) {
      this.rows = this.temp;
      return false;
    }
    const val = this.selectedStatus;

    const temp = this.temp.filter(function (d) {
      return d.flg_status.toString() === val.toString();
    });

    this.rows = temp;
    this.table.offset = 0;
  }

  onEdit(id) {
    this.router.navigate(['rastreador-modelo/editar/', id]);
  }

  async onDelete(id: number) {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: "Esta ação não poderá ser revertida!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        this.loading = true;
        await this.rastreadorModeloService.remove(id);
        
        // Recarrega os dados da tabela
        const result = await this.rastreadorModeloService.findAll();
        this.rows = Array.isArray(result) ? result : [];
        this.temp = Array.isArray(result) ? [...result] : [];
        
        Swal.fire(
          'Deletado!',
          'O modelo de rastreador foi deletado com sucesso.',
          'success'
        );
      } catch (error) {
        console.error('Erro ao deletar modelo de rastreador:', error);
        Swal.fire(
          'Erro!',
          'Ocorreu um erro ao deletar o modelo de rastreador.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    }
  }

  public onCreate(): void {
    this.router.navigate(['rastreador-modelo/cadastro']);
  }
}
